export default "__VITE_ASSET__BkzrHo_Q__"